var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{staticClass:"col-sm"},[_c('b-form-input',{attrs:{"disabled":_vm.disabled,"placeholder":"Поиск"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":_vm.disabled,"variant":"primary"},on:{"click":_vm.search}},[_vm._v("Найти")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }